import React, { memo } from "react";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { HelpButton } from "../../styles/help";
import { DLS_TEXT_VARIANTS } from "../../constants/dls";
import { HELP_FORM_URL } from "./constants";
import { logHelpClick } from "../home/analytics";

const Help = () => {
    const handleHelpClick = () => {
        logHelpClick();
        window.open(HELP_FORM_URL);
    };

    return (
        <HelpButton onClick={handleHelpClick}>
            <Text variant={DLS_TEXT_VARIANTS.BODY_B3_BOLD} color="background_Button_Primary">
                Help
            </Text>
        </HelpButton>
    );
};

export default memo(Help);
